// Deployed app URL — used in companion notes for universal link sharing
export const APP_URL = 'https://torchlite.shakespeare.wtf';

// OG image — attached to companion notes for cross-client visual presence
export const OG_IMAGE_URL = `${APP_URL}/og-image.jpg`;

// Torchlite event kind constants
export const TORCH_GENESIS_KIND = 30910;
export const TORCH_PASS_KIND = 1910;    // Published by passer after zapping recipient
export const ZAP_RECEIPT_KIND = 9735;
export const COMPANION_NOTE_KIND = 1;

// Default genesis parameters
export const DEFAULT_TTL_HOURS = 168; // 1 week — how long each holder has to pass

// The very first pass always costs at least this many sats
export const GENESIS_ZAP_SATS = 21;

/**
 * Minimum sats required for the next pass.
 * Rule: every pass must exceed the previous one by at least 1 sat.
 *
 * @param lastZapAmount  Sats in the most recent pass (0 if genesis hasn't been passed yet)
 */
export function calculateMinimumZap(lastZapAmount: number): number {
  if (lastZapAmount <= 0) return GENESIS_ZAP_SATS;
  return lastZapAmount + 1;
}
